import { useContext } from "react";
import { ProfilWidgetItem } from "../../../types";
import { Box } from "@mui/material";
import ProfilWidget from "./ProfilWidget";
import { InnerWidthContext } from "../../../contexts";

type ProfilsWidgetsProps = {
    profilWidgetItems: ProfilWidgetItem[];
};

export default function ProfilWidgets({
    profilWidgetItems,
}: ProfilsWidgetsProps) {
    const { isMobile } = useContext(InnerWidthContext);

    return (
        <Box
            sx={{
                display: isMobile ? "inline-flex" : "flex",

                flexDirection: "column",
                alignItems: "flex-start",
                gap: "1rem",
            }}
        >
            {profilWidgetItems.map(
                (profilWidgetItem: ProfilWidgetItem, idx: number) => (
                    <ProfilWidget
                        key={idx}
                        profilWidgetItem={profilWidgetItem}
                    />
                )
            )}
        </Box>
    );
}
